import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionPorcelain = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
                What are porcelain veneers?
              </Accordion.Header>
              <Accordion.Body>
                Porcelain veneers are thin, custom-made shells that are
                carefully fitted over the front surface of your teeth to enhance
                their appearance, giving you a beautifully natural and confident
                smile.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                What concerns can veneers fix?
              </Accordion.Header>
              <Accordion.Body>
                Veneers are a wonderful solution for chipped, discoloured,
                uneven, gappy or slightly misaligned teeth. They can transform
                your smile with minimal preparation.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is the process for getting veneers?
              </Accordion.Header>
              <Accordion.Body>
                We’ll start with a detailed consultation to understand your
                goals. Then, we’ll carefully prepare your teeth, take
                impressions, and fit your bespoke veneers once they’re ready -
                all with your comfort in mind.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long do porcelain veneers last?
              </Accordion.Header>
              <Accordion.Body>
                With good care, porcelain veneers can last 10–15 years or even
                longer. We’ll give you all the advice you need to look after
                them and keep your smile shining.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will my veneers look natural?
              </Accordion.Header>
              <Accordion.Body>
                Absolutely. At Regent Dental, we pride ourselves on creating
                veneers that look beautifully natural, carefully matching the
                colour, shape, and size to suit your face and smile.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                Are veneers permanent?
              </Accordion.Header>
              <Accordion.Body>
                Because a small amount of enamel is removed during preparation,
                veneers are considered a permanent treatment. We’ll make sure
                you feel fully informed and comfortable before going ahead.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                Does it hurt to have veneers fitted?
              </Accordion.Header>
              <Accordion.Body>
                The process is gentle and should not be painful. We’ll use a
                local anaesthetic if needed to keep you completely comfortable
                during the preparation stage.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can I have veneers on just one or two teeth?
              </Accordion.Header>
              <Accordion.Body>
                Yes, you can. Whether you’d like to improve just a single tooth
                or achieve a full smile makeover, we’ll create a treatment plan
                that’s tailored perfectly to you.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="10"
              onClick={() => handleToggle("10")}
            >
              <Accordion.Header as="h3" className="red-header">
                How do I look after my veneers?
              </Accordion.Header>
              <Accordion.Body>
                Caring for veneers is very similar to caring for natural teeth –
                brush twice daily, floss regularly, attend your dental
                check-ups, and avoid using your teeth as tools!
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="11"
              onClick={() => handleToggle("11")}
            >
              <Accordion.Header as="h3" className="red-header">
                Are veneers right for me?
              </Accordion.Header>
              <Accordion.Body>
                If you’re dreaming of a straighter, whiter, or more even smile,
                veneers could be a wonderful option. We’d love to invite you in
                for a consultation to chat through what’s possible.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionPorcelain;
